import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'meu-app-home-page-product-list',
  templateUrl: './app-home-page-product-list.component.html',
  styleUrls: ['./app-home-page-product-list.component.scss']
})
export class AppHomePageProductListComponent implements OnInit {

  constructor() { }
  lstProduct = [
    {name: 'Electrical', img:'/assets/media/webshop/Electrical.jpg'},
    {name: 'Brakes and cables', img:'/assets/media/webshop/Brakes-and-cables.jpg'},
    {name: 'Drive train and  Steerring', img:'/assets/media/webshop/Drive-train-and-Steerring.jpg'},
    {name: 'Phụ tùng xe máy', img:'/assets/media/webshop/moto1.jpg'},
    {name: 'Hydraulics', img:'/assets/media/webshop/Hydraulics.jpg'},
    {name: 'cabs, seats and hoods', img:'/assets/media/webshop/cabs-seats-and-hoods.jpg'},
    {name: 'Handling warehouse', img:'/assets/media/webshop/Handling-warehouse.jpg'},
    {name: 'Phụ tùng xe máy', img:'/assets/media/webshop/moto2.jpg'},
    {name: 'Brakes and cables', img:'/assets/media/webshop/Brakes-and-cables-2.jpg'},
  ];
  ngOnInit() {
  }

}
